import { useNavigate } from "react-router";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { PencilIcon } from "@heroicons/react/24/outline";
import { localeShortDateTime } from "../../app/datetimeUtils";
import { useAppSelector } from "../../app/hooks";
import { ClassLinkOrCleverIcon } from "../../components/ClassLinkOrCleverIcon";
import { CourseListViewModel } from "./schoolsApiSlice";

interface SchoolCoursesTableProps {
	courses: CourseListViewModel[];
}

export default function SchoolCoursesTable(props: SchoolCoursesTableProps) {
	const { config } = useAppSelector((state) => state.site);

	const navigate = useNavigate();

	const hasClassLinkOrCleverCourse = props.courses.some(
		(c) => c.isClassLinkCourse || c.isCleverCourse
	);

	const createDateBodyTemplate = (row: CourseListViewModel) => {
		return <span>{localeShortDateTime(row.createDate)}</span>;
	};

	const cleverOrClassLinkBodyTemplate = (row: CourseListViewModel) => {
		return (
			<ClassLinkOrCleverIcon
				isClassLinkEntity={row.isClassLinkCourse}
				isCleverEntity={row.isCleverCourse}
			/>
		);
	};

	const editBodyTemplate = (row: CourseListViewModel) => {
		return (
			<button
				id={`edit-${row.courseId}-button`}
				className="mr-2 cursor-pointer"
				onClick={() => navigate(`/schools/course?courseId=${row.courseId}`)}>
				<PencilIcon className="size-5" />
			</button>
		);
	};

	return (
		<DataTable
			value={props.courses}
			dataKey="courseId"
			emptyMessage="No courses found"
			stripedRows
			className="tbl tbl-data tbl-datatable min-w-[40rem] cursor-default"
			style={{ paddingTop: "16px" }}>
			<Column header="Created" body={createDateBodyTemplate}></Column>
			{!config?.isUtahComposeSite && hasClassLinkOrCleverCourse && (
				<Column
					body={cleverOrClassLinkBodyTemplate}
					headerClassName="!px-0 w-4"
					className="!px-0"></Column>
			)}
			<Column header="Name" field="name"></Column>
			<Column header="External ID" field="externalID"></Column>
			<Column header="Referral Code" field="referralCode"></Column>
			<Column header="Status" field="status"></Column>
			<Column header="Grade" field="grade"></Column>
			<Column header="Students" field="writerCount"></Column>
			<Column body={editBodyTemplate} className="!pl-1 !pr-2"></Column>
		</DataTable>
	);
}
